import type { useSnackbars } from '@customerio/pluma-components/react';

type Snackbars = ReturnType<typeof useSnackbars>;

/**
 * What this page says after a write.
 *
 * Shared by both generations of the connector because the sentences and their ids
 * are the same on either form — a reader whose workspace is moved from one to the
 * other should not see the wording change, and there is nothing form-specific to
 * say: which endpoint was written to is not the reader's concern.
 *
 * Ember's two forms carried these strings separately, and this is where they met.
 */
export function notifySettingsSaved(snackbars: Snackbars): void {
  snackbars.create({
    variant: 'default',
    id: 'segment-out.success',
    message: 'Segment source integration settings saved',
  });
}

export function notifySettingsSaveFailed(snackbars: Snackbars): void {
  snackbars.create({
    variant: 'critical',
    id: 'segment-out-save.error',
    message: 'Could not update Segment source integration. Try again.',
  });
}

export function notifyConnectorRemoved(snackbars: Snackbars): void {
  snackbars.create({
    variant: 'default',
    id: 'segment-out-delete.success',
    message: 'Segment source integration removed',
  });
}

export function notifyConnectorRemoveFailed(snackbars: Snackbars): void {
  snackbars.create({
    variant: 'critical',
    id: 'segment-out-delete.error',
    message: 'Could not remove Segment source integration. Try again.',
  });
}
